import React, { useEffect, useState, useMemo } from 'react';
import Layout from '../components/layout/Layout';
import TestMasterList from '../components/testmasters/TestMasterList';
import PaginationControls from '../components/testmasters/PaginationControls';
import TestMasterModal from '../components/testmasters/TestMasterModal';
import { TestMasterProvider } from '../contexts/TestMasterContext';

const TestMastersPage = () => {
  return (
  
    <Layout>
      <TestMasterProvider>
        {/* Page header removed as requested */}
        
        <TestMasterList />
        
        {/* Modal for creating/editing test masters */}
        <TestMasterModal />
      </TestMasterProvider>
    </Layout>
  );
};

export default TestMastersPage;
